import React, { Fragment, useState, useEffect } from "react";
import { connect } from "react-redux";
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import Grid from '@mui/material/Grid';
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import { selectMenuProps } from "../../../utils/selectMenuProps";

const labelColorStyle = { color: "#000" };
const addNewSwitchesButtonSx = { marginTop: "10px" };
const selectInputSx = { height: "3rem", width: "100%" };
const deleteButtonSx = { float: "left" };
const inputFieldsSx = { marginLeft: '5px' };

const ChannelAndSwitches = ({
    channelAndSwitchDevices,
    deviceTypes,
    addChannelAndSwitches
}) => {
    const [channelCount, setChannelCount] = useState(0)
useEffect(() => {
        if (channelAndSwitchDevices && channelAndSwitchDevices.length > 0) {
            setChannelCount(channelAndSwitchDevices.length);
        }
    }, []);
    function onAddNewDevice() {
        let updatedChannelsAndSwitches = [...channelAndSwitchDevices]
        updatedChannelsAndSwitches.push({
            name: "",
            channel: ('0' + (channelCount)).slice(-2),
            type: ""
        })

        addChannelAndSwitches(updatedChannelsAndSwitches)

        setChannelCount(channelCount + 1)
    }

    function onChangeDeviceName(index, name) {
        let elements = [...channelAndSwitchDevices]
        elements[index].name = name

        addChannelAndSwitches(elements)
    }

    function onChangeDeviceType(index, type) {
        let elements = [...channelAndSwitchDevices]
        elements[index].type = type

        addChannelAndSwitches(elements)
    }

   function onDeleteDevice(indexToDelete) {
    let updatedChannelsAndSwitches = channelAndSwitchDevices.filter((element, index) => {
        return index !== indexToDelete;
    });

    // Recalculate channels to ensure 00, 01, 02, etc.
    updatedChannelsAndSwitches = updatedChannelsAndSwitches.map((element, index) => {
        return {
            ...element,
            channel: ('0' + (index)).slice(-2)
        };
    });

    addChannelAndSwitches(updatedChannelsAndSwitches);
    setChannelCount(updatedChannelsAndSwitches.length);
}
    
    return (
        <Fragment>
            <div className="row">
                <div className={`s2 col`}>
                    <label className="title d-inline min-180" style={labelColorStyle}>Devices and Switches</label>
                    {/* <br></br> */}
                    <button
                        className="btn btn-style-2 orange-bg mr-5" style={addNewSwitchesButtonSx}
                        onClick={() => {
                            onAddNewDevice()
                        }}
                    >
                        Add New Device
                    </button>
                </div>
            </div>
            {
                channelAndSwitchDevices && channelAndSwitchDevices.map((switchElement, index) => {
                    return <div key={index} className="row">
                        <Grid container>
                            <Grid item xs={2}>
                                <input
                                    placeholder="Channel"
                                    className="add-input xl"
                                    value={channelAndSwitchDevices[index]['channel']}
                                    type="text"
                                    disabled={true}
                                />
                            </Grid>
                            <Grid item xs={2} sx={inputFieldsSx}>
                                <FormControl variant="outlined" sx={selectInputSx}>
                                    <InputLabel id="select-outlined-label-values">Select Device Type</InputLabel>
                                    <Select
                                        labelId="select-outlined-label-values"
                                        id="select-outlined-values-id"
                                        value={channelAndSwitchDevices[index]["type"]}
                                        onChange={(e) => {
                                            onChangeDeviceType(index, e.target.value)
                                        }}
                                        label="Select Device Type"
                                        inputProps={{ 'aria-label': 'Without label' }}
                                        sx={selectInputSx}
                                        MenuProps={selectMenuProps}
                                    >
                                        {
                                            Object.keys(deviceTypes).map(deviceType => {
                                                return <MenuItem key={deviceType} value={deviceType}>{deviceTypes[deviceType]}</MenuItem>
                                            })
                                        }
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item xs={2} sx={inputFieldsSx}>
                                <input
                                    placeholder="Enter Device Name"
                                    className="add-input xl"
                                    value={channelAndSwitchDevices[index]["name"]}
                                    type="text"
                                    onChange={(e) => {
                                        onChangeDeviceName(index, e.target.value)
                                    }}
                                />
                            </Grid>
                            <Grid item xs={1}>
                                <IconButton aria-label="delete" onClick={(e) => { onDeleteDevice(index) }}
                                    sx={deleteButtonSx}>
                                    <DeleteIcon fontSize="small" />
                                </IconButton>
                            </Grid>
                        </Grid>
                    </div>
                })
            }
        </Fragment>
    )
}

const mapStateToProps = (state) => ({
    ModelData: state.getModel
});

export default connect(mapStateToProps)(ChannelAndSwitches);